import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useAlert } from './use-alert';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '10px auto',
    maxWidth: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export const AlertInfos = () => {
  const classes = useStyles();
  const { alerts, remove } = useAlert();

  const handleClose = (index: number, event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    remove(index);
  };

  return (
    <div className={classes.root}>
      {alerts.map((alert, index) => (
        <Snackbar
          open
          autoHideDuration={3000}
          onClose={(evt, reason) => handleClose(index, evt, reason)}
        >
          <Alert severity={alert.severity} onClose={() => handleClose(index)}>
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </div>
  );
};

export default AlertInfos;
